module.exports = __webpack_public_path__ + "img/document.79e6ed7e.svg";